import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import {
  Typography,
  CardContent,
  Menu,
  Button,
  Input,
  InputAdornment,
  IconButton,
  Card,
  MenuItem,
  CardHeader,
  Switch,
  Modal,
  TextField
} from "@material-ui/core";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import SearchIcon from "@material-ui/icons/Search";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import { getLastId } from "../../helpers";

const EditModal = ({ classes, mappingForEdit, showEditModal, changeState }) => (
  <Modal
    aria-labelledby="simple-modal-title"
    aria-describedby="simple-modal-description"
    open={showEditModal}
    onClose={() => changeState({ showEditModal: false })}
  >
    <div
      style={{
        top: "50%",
        left: "50%",
        transform: `translate(-50%, -50%)`
      }}
      className={classes.paper}
    >
      <h3 id="modal-title" className={classes.modalTitle}>
        Edit a Mapping
      </h3>
      <TextField
        id="standard-name"
        label="Mapping name"
        className={classes.modalTextField}
        value={mappingForEdit !== null ? mappingForEdit.title : ""}
        onChange={event => {
          const value = event.target.value;
          changeState(state => ({
            mappingForEdit: {
              ...state.mappingForEdit,
              title: value
            }
          }));
        }}
        margin="normal"
      />
      <div className={classes.modalControl}>
        <Button
          variant="contained"
          color="primary"
          className={classes.modalButton}
          onClick={() =>
            changeState(state => ({
              showEditModal: false,
              mappingForEdit: null,
              mappings: state.mappings.map(
                mapping =>
                  mapping.id === mappingForEdit.id
                    ? {
                        ...mapping,
                        title: mappingForEdit.title
                      }
                    : mapping
              )
            }))
          }
        >
          Save
        </Button>
        <Button
          className={classes.modalButton}
          onClick={() => changeState({ showEditModal: false })}
        >
          Cancel
        </Button>
      </div>
    </div>
  </Modal>
);

const DashboardCard = ({
  classes,
  menuEl,
  handleMenuClose,
  handleMenuClick,
  handleEditModal,
  mapping: { id, title, subtitle },
  deleteCard,
  duplicateCard
}) => (
  <Card className={classes.card}>
    <CardHeader
      action={
        <React.Fragment>
          <IconButton id={`mapping_${id}`} onClick={handleMenuClick}>
            <MoreVertIcon />
          </IconButton>
          <Menu
            id={`mapping-menu_${id}`}
            anchorEl={menuEl}
            open={Boolean(menuEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleEditModal}>Edit</MenuItem>
            <MenuItem onClick={deleteCard}>Delete</MenuItem>
            <MenuItem onClick={duplicateCard}>Duplicate</MenuItem>
            <MenuItem>
              <p className={classes.menu_toggle_text}>Publish</p>
              <Switch value="checkedB" color="primary" />
            </MenuItem>
          </Menu>
        </React.Fragment>
      }
      title={title}
      subheader={subtitle}
    />
    <CardContent>
      <Typography component="p">
        This impressive paella is a perfect party dish and a fun meal to cook
        together with your guests. Add 1 cup of frozen peas along with the
        mussels, if you like.
      </Typography>
    </CardContent>
  </Card>
);

class Mappings extends React.Component {
  state = {
    search: "",
    menuEl: null,
    mappingForEdit: null,
    showEditModal: false,
    mappings: [
      {
        title: "Mapping 1",
        subtitle: "Version XYZ",
        id: 1
      },
      {
        title: "Mapping 2",
        subtitle: "Version XYZ",
        id: 2
      },
      {
        title: "Mapping 3",
        subtitle: "Version XYZ",
        id: 3
      }
    ]
  };

  handleMenuClick = event => {
    const target = event.currentTarget;
    const mappingId = parseInt(
      target.id.toString().replace(/mapping_/, ""),
      10
    );
    this.setState(state => ({
      menuEl: target,
      mappingForEdit: state.mappings.find(mapping => mapping.id === mappingId)
    }));
  };

  handleMenuClose = () => {
    this.setState({ menuEl: null });
  };

  handleChange = prop => event => {
    this.setState({ [prop]: event.target.value });
  };

  duplicateCard = () => {
    this.setState(state => ({
      menuEl: null,
      mappings: [
        ...state.mappings,
        { ...state.mappingForEdit, id: getLastId(state.mappings) + 1 }
      ]
    }));
  };

  deleteCard = () => {
    const { mappingForEdit } = this.state;
    this.setState(state => ({
      menuEl: null,
      mappings: state.mappings.filter(
        mapping => mapping.id !== mappingForEdit.id
      )
    }));
  };

  handleEditModal = () => {
    this.setState({
      menuEl: null,
      showEditModal: true
    });
  };

  render() {
    const { classes } = this.props;
    const {
      mappings,
      menuEl,
      search,
      showEditModal,
      mappingForEdit
    } = this.state;
    return (
      <div>
        <div className={classes.header}>
          <h2>Mapping</h2>
          <Input
            id="adornment-password"
            value={search}
            onChange={this.handleChange("search")}
            placeholder="Search…"
            className={classes.header_input}
            endAdornment={
              <InputAdornment position="end">
                <IconButton aria-label="">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            }
          />
          <Button
            variant="contained"
            className={classes.header_button}
            onClick={() => this.props.history.push("/new/mapping")}
          >
            New
          </Button>
        </div>
        <GridContainer>
          {mappings.map(mapping => (
            <GridItem
              xs={12}
              sm={6}
              md={4}
              key={`${mapping.title}_${mapping.id}`}
            >
              <DashboardCard
                classes={classes}
                menuEl={menuEl}
                handleMenuClick={this.handleMenuClick}
                handleMenuClose={this.handleMenuClose}
                handleEditModal={this.handleEditModal}
                mapping={mapping}
                deleteCard={this.deleteCard}
                duplicateCard={this.duplicateCard}
              />
            </GridItem>
          ))}
        </GridContainer>
        <EditModal
          changeState={data => this.setState(data)}
          classes={classes}
          showEditModal={showEditModal}
          mappingForEdit={mappingForEdit}
        />
      </div>
    );
  }
}

export default withStyles(dashboardStyle)(Mappings);
